/**
 * Initializes header functionality, including the mobile menu toggle
 * and a sticky header effect on scroll.
 */
export const initHeader = (): void => {
  const header = document.querySelector<HTMLElement>(".site-header");
  const mobileToggle = document.querySelector<HTMLButtonElement>(
    ".site-header__mobile-toggle"
  );
  const navigation = document.querySelector<HTMLElement>("#site-navigation");
  const TABLET_BREAKPOINT = 768; // Must match $breakpoint-tablet in SCSS

  if (!header || !mobileToggle || !navigation) {
    console.warn("[Header] Required header elements not found.");
    return;
  }

  // --- Mobile Menu Toggle ---
  const closeMobileMenu = () => {
    document.body.classList.remove("mobile-menu-is-open");
    mobileToggle.setAttribute("aria-expanded", "false");
  };

  const openMobileMenu = () => {
    document.body.classList.add("mobile-menu-is-open");
    mobileToggle.setAttribute("aria-expanded", "true");
  };

  const toggleMobileMenu = () => {
    const isExpanded = mobileToggle.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  };

  mobileToggle.addEventListener("click", toggleMobileMenu);

  // --- Sticky Header Effect ---
  const handleScroll = () => {
    if (window.scrollY > 50) {
      header.classList.add("is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
    }
  };

  // --- Resize Listener to prevent stuck state ---
  const handleResize = () => {
    if (window.innerWidth > TABLET_BREAKPOINT) {
      // If we're on a desktop-sized view, ensure the mobile menu is closed.
      if (document.body.classList.contains("mobile-menu-is-open")) {
        closeMobileMenu();
      }
    }
  };

  // Check on load
  handleScroll();
  // Add listeners
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleResize, { passive: true });

  console.log("[Header] Initialized.");
};
